import React from 'react'
import { Link } from 'react-router-dom'
import ReactGa from 'react-ga'
import { Grid, Box, makeStyles } from '@material-ui/core'
import Breadcrumbs from '../components/Breadcrumbs'
import clsx from 'clsx'


const useStyles = makeStyles((theme) => ({
  aboutTop: {
    backgroundColor: `#FFF`,
    flexDirection: `column`,
    padding: `2.5rem 5rem 1rem`,
    width: `100%`,
    [theme.breakpoints.up('md')]: {
      flexDirection: `row`,
      padding: `2.5rem 10rem 1rem`,
    },
    [theme.breakpoints.up('lg')]: {
      padding: `2.5rem 15rem 1rem`,
    },
    [theme.breakpoints.up('xl')]: {
      padding: `2.5rem 21.75rem 1rem`,
    },
  },
  aboutHeader: {
    color: `#1E2553`,
    fontSize: `2.5rem`,
    lineHeight: `3rem`,
  },
  contactLink: {
    color: `#009ECC`,
    marginBottom: `2.5rem`,
  },
  faqBottomBox: {
    backgroundColor: `#FFF`,
    margin: `0 auto 2.5rem`,
    maxWidth: `92.5%`,
    width: `92.5%`,
    padding: `2rem 0`,
    [theme.breakpoints.up('sm')]: {
      margin: `0 auto 2.5rem`,
      maxWidth: `80%`,
      width: `80%`,
    },
    [theme.breakpoints.up('md')]: {
      margin: `0 auto 2.5rem`,
      maxWidth: `80rem`,
      width: `70%`,
    },
  },
  faqBottomBoxFirst: {
    marginTop: `2rem`,
  },
  faqBottomBoxLast: {
    marginBottom: `13.5rem`,
  },
  sectionHeader: {
    color: `#707070`,
    fontSize: `1.25rem`,
    lineHeight: `2.25rem`,
    paddingBottom: `2rem`
  },
  
  sectionContent: {
    position: `relative`,
    display: `flex`,
    justifyContent: 'space-between',
    marginBottom: `3.75rem`
  },

  jobDetails: {
    color: `#FFFFFF`,
    cursor: `pointer`,
    backgroundColor: `#1E2553`,
    padding: `0.5625rem 2.5rem`,
    textAlign: `center`,
    textDecoration: `none`,
    '&:hover': {
      textDecoration: `none`,
    },
    [theme.breakpoints.up('md')]: {
      width: `auto`,
    },
    borderRadius: '3px',
    boxShadow: '0 2px 2px #70707066',
  },
}))

const AboutPage = () => {
  const classes = useStyles()
  const PROJECT_SUBMISSION_LINK = process.env.REACT_APP_PROJECT_SUBMISSION_LINK

  const submitProjectAnalytics = () => {
    ReactGa.event({
      category: "Submit Project",
      action: "Click To Submit"
    })
  }


  return (
    <Grid container>
      <Breadcrumbs crumbs={[{ text: `Submission`, path: `/submission` }]} />
      <Box className={clsx(classes.aboutTop, classes.aboutTopFirst)}>
      <h2 className={classes.aboutHeader}>Submit Project</h2>
      <p className={clsx(classes.sectionHeader, classes.sectionHeaderQuestion)}>
            <b>Only Principal Investigators (PIs) or those acting directly on their behalf can submit projects.</b>
            <br /> Submissions are tracked by Campus Key. Please confirm that you are a Principal Investigators (PI) or acting directly on their behalf.
      </p>

       <Box className={classes.sectionContent}>
            <a
              href={PROJECT_SUBMISSION_LINK}
              className={classes.jobDetails}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => submitProjectAnalytics}
            >
              YES
            </a>

            <Link
              to={`/`}
              className={classes.jobDetails}
            >
              NO
            </Link>

          </Box>
      </Box>      
    </Grid>
  )
}

export default AboutPage
